module.exports = __webpack_public_path__ + "static/media/partner-site-b-1.772d37ab.png";